import {notification} from "antd";
import {useHistory} from "react-router-dom";
import {CurrencyType} from "./Enums";

export function formatDate(dateString) {
    const date = new Date(dateString);

    const monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];
  
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
  
    return monthNames[monthIndex] + ' ' + year;
}

export function showAxiosError(error) {
    if (error && error.data) {
        if (error.data.errors && error.data.errors.length > 0) {
            notification.error({
                message: "Hata",
                description: error.data.errors[0].detail
            });
        } else {
            notification.error({
                message: "Hata",
                description: error.data
            });
        }
    } else {
        notification.error({
            message: "Hata",
            description: "Şuan işleminiz gerçekleştirilemiyor."
        });
    }
}

export function createImageUrl(item, propertyName) {
    if (item && item[propertyName]) {
        return "data:image/jpeg;base64," + item[propertyName];
    } else {
        return require(`../assets/no-image.jpg`);
    }
}

export function getCurrencyTypeSuffix(currency) {
    if (CurrencyType.EURO.value === currency) {
        return CurrencyType.EURO.suffix;
    } else if (CurrencyType.USD.value === currency) {
        return CurrencyType.USD.suffix;
    } else if (CurrencyType.TRY.value === currency) {
        return CurrencyType.TRY.suffix;
    }
}


// WEBPACK FOOTER //
// ./src/util/Helpers.js